import Vue from 'vue';

const success = (data, context) => {
  toastr.success(data.msg);
  context.generateDownloadableCSVLink(data.csvData, 'generated_file.csv');
  context.closeModal('#tax-modal');
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (taxData, context) => Vue.$http.post('calendars/generate-tax-csv', taxData).then((response) => {
  if (response && response.status === 200) {
    success(response.data, context, taxData);
  }
})
  .catch((error) => {
    failed(context, error);
  });



// WEBPACK FOOTER //
// ./src/app/services/calendar/generateTaxCsv.js